import { ImagePlus, Trash2 } from "lucide-react";
import { useState } from "react";
import { resolveMediaUrl } from "../../lib/api";
import { MediaPicker } from "./MediaPicker";

export const MediaField = ({ label, onChange, testId, value }) => {
  const [open, setOpen] = useState(false);
  return <div className="admin-media-field" data-testid={testId}>
    <span>{label}</span>
    <div className="admin-media-field-preview">{value ? <img src={resolveMediaUrl(value)} alt="Selected" /> : <ImagePlus />}</div>
    <div><button className="admin-secondary-action" onClick={() => setOpen(true)}><ImagePlus /> Select / upload</button>{value && <button className="admin-danger-action" onClick={() => onChange("")}><Trash2 /> Remove</button>}</div>
    <MediaPicker open={open} onClose={() => setOpen(false)} onSelect={(asset) => onChange(asset.url)} title={label} />
  </div>;
};